var imageIconTrend = require("url:../../images/iconotrend.png");

var s = function (sketch, canvasParent, question, text, nextIDs, color) {
  var sD, sX, sY, sDc;
  var dD, dX, dY;
  
  var t = 0;
  var move = true;
  var isInside = false;
  
  var r, g, b, a;
  var rShine, gShine, bShine, aShine;
  var sBrillo;
  var xBrillo, yBrillo;
  var questionChoice = null;
  
  var icono;

  sketch.setup = function () {
    var windowWidth = sketch.windowWidth;
    var windowHeight = sketch.windowHeight;

    var canvas = sketch.createCanvas(windowWidth, windowHeight);
    canvas.parent(canvasParent);
    

    //img2020 = sketch.loadImage(image2020corner); // ------need to set the root path!!
    icono = sketch.loadImage(imageIconTrend);// -----need to set the root path!!

    sD = 90;
    sDc = 30;
    sX = windowWidth / 2;
    sY = windowHeight / 1.6;
    dD = 78;
    dX = sketch.random(windowWidth);
    dY = sketch.random(windowHeight);
    
    r = color.r;
    g = color.g;
    b = color.b;
    a = 100;
    rShine = color.r;
    gShine = color.g;
    bShine = color.b;
    aShine = 60;
    sBrillo = 100;
    xBrillo = sX;
    yBrillo = sY;

    questionChoice = sketch.random(question);
  }
 //questionChoice = sketch.random(question);
 
  sketch.draw = function () {
    var width = sketch.width;
    var height = sketch.height;
    sketch.background(0, 30); //si lo dejo en 70 se ve bien el brillo, pero la pelota tiene menor halo.

    //SHINE STATIC BALL
    shineBall();

    //STATIC ELLIPSE
    sketch.stroke(rShine, gShine, bShine);
    sketch.noFill();
    sketch.strokeWeight(4);
    sketch.ellipse(sX, sY, sD, sD);
    sketch.noStroke();
    sketch.fill(255);
    sketch.ellipse(sX, sY, sDc, sDc);

    //TEXT
    sketch.fill(255);
    sketch.noStroke();
    sketch.textSize(12);
    sketch.textFont('Rajdhani');
    sketch.text("Drop the ball here for prediction", width / 2, height / 1.3);


    if (move) {
      //DYNAMIC BALL
      dX = width * sketch.noise(t);
      dY = height * sketch.noise(t + 2);
      t = t + 0.003;
    }
    sketch.fill(r, g, b);
    sketch.ellipse(dX, dY, dD, dD);
      
    //QUESTION TEXT
    questionText();
    
    //imagen 2020
    //sketch.image(img2020, 0, 0);

    //imagen icono
    sketch.image(icono, width - 100, height - 100, 80, 80);

    //TREND TITLE
    trendTitle();

    //TREND LATERAL
    trendLateral();

    var d = sketch.dist(sX, sY, dX, dY);
    if (d < sD / 2 && !move) {

      dX = sketch.width / 2;
      dY = sketch.height / 1.6;
      isInside=true;  // I don't know if this isInside function the problem...
      // When the ball go inside turn white, after the time and reset y goes back to the begining color.
      r = 255;
      g = 255;
      b = 255;
      a = 100;
    }
  }

  // moveBall = function () {
  //   dX = sketch.width * sketch.noise(t);
  //   dY = sketch.height * sketch.noise(t + 2);
  //   t = t + 0.003;
  // }
  


  //DRAGGED BALL
  sketch.mouseDragged = function () {
    var d = sketch.dist(sketch.mouseX, sketch.mouseY, dX, dY);
    if (d < dD / 2) {
      dX = sketch.mouseX;
      dY = sketch.mouseY;
      move = false;
    }
  }

  //RELEASE MOUSE
  sketch.mouseReleased = function () {
    if(isInside === false){
      move = true;
    } else {
      setTimeout(jump, 100); ///decide time before jump
    }
  }

  //SHINE STATIC BALL function
  function shineBall() {
    sketch.noFill();
    sketch.stroke(rShine, gShine, bShine, aShine);
    sketch.strokeWeight(3);
    sBrillo = sBrillo + 5
    sketch.ellipse(xBrillo, yBrillo, sBrillo, sBrillo);

    // diameter of the shine, start again
    if (sBrillo > 200) {
      sBrillo = 100;
    }
  }

  

  //QUESTION function
  function questionText() {
    var width = sketch.width;
    var height = sketch.height;

    //style text 
    sketch.textFont('Fira Sans');
    sketch.textStyle(sketch.BOLD);

    //textAlign(CENTER);//
    sketch.textAlign(sketch.CENTER, sketch.BASELINE)
    sketch.textSize(56);
    sketch.stroke(0);
    sketch.strokeWeight(2);
    sketch.text(questionChoice, width / 4.4, height / 4.4, 800, 300);
    sketch.fill(255);
    sketch.text(questionChoice, width / 4.4, height / 4.4, 800, 300);
  }


  
  //TREND TITLE function
  function trendTitle() {
    var width = sketch.width;
    var height = sketch.height;
    sketch.textAlign(sketch.CENTER)
    sketch.fill(255);
    sketch.noStroke();
    sketch.textSize(20);
    sketch.textFont('Rajdhani');
    sketch.text(text, width / 2, height / 9 - 20);
  }

  //TREND LATERAL function
  function trendLateral() {
    var width = sketch.width;
    var height = sketch.height;
    sketch.textAlign(sketch.CENTER)
    sketch.fill(255);
    sketch.noStroke();
    sketch.textSize(27);
    sketch.textFont('Rajdhani');
    sketch.push();
    sketch.translate(width / 9 - 50, height / 2);
    sketch.rotate(-sketch.PI/2); 
    sketch.text('TREND', 0,0);
    sketch.pop();
  }

  function jump() {
    r = color.r;
    g = color.g;
    b = color.b;
    a = 100;
    move = true;
    isInside = false;
    
    ///go to section
    if(questionChoice == question[0]){
      
      //jump to first section
      // https://greensock.com/ScrollToPlugin
      gsap.to(window, {duration: 2, scrollTo: nextIDs[0]});
      
    }else{
      //jump two second one
      // https://greensock.com/ScrollToPlugin
      
      gsap.to(window, {duration: 2, scrollTo: nextIDs[1]});
    }
    questionChoice = sketch.random(question);
    
  }
}

var data = [
  {
    question: ["Will the future of cinema become a personalized 360° immersive experience?", "Triggering five senses: Will this change the way we experience movies?"],
    canvasParent: "question-cinema",
    text: "CINEMA",
    nextIDs: ["#cin-trend-01", "#cin-trend-02"],
    color: {
      r: 243,
      g: 42,
      b: 59
    },
  },
  {
    question: ["Will virtual senses become the main pillar of Smart Cities?", "Will the Human - AI Hybrids become the new normal?"],
    canvasParent: "question-art",
    text: "ART & DESIGN",
    nextIDs: ["#art-trend-01", "#art-trend-02"],
    color: {
      r: 245,
      g: 196,
      b: 22
    }
  },
  {
    question: ["How could smart implante chips be the future of thinking?", "Will AI be tomorrow's teachers?"],
    canvasParent: "question-edu",
    text: "EDUCATION",
    nextIDs: ["#edu-trend-01", "#edu-trend-02"],
    color: {
      r: 19,
      g: 214,
      b: 185
    }
  },
  {
    question: ["Listening to audio in 8D is now a thing, so how does it work?", "How can sounds be delivered to the people that can’t hear?"],
    canvasParent: "question-mus",
    text: "MUSIC",
    nextIDs: ["#mus-trend-01", "#mus-trend-02"],
    color: {
      r: 177,
      g: 92,
      b: 250
    }
  },
  {
    question: ["How will wearable technology be revolutionized? ", "Will Eco-friendly Fashion become the future?"],
    canvasParent: "question-fas",
    text: "FASHION",
    nextIDs: ["#fas-trend-01", "#fas-trend-02"],
    color: {
      r: 255,
      g: 117,
      b: 61
    }
  },
  {
    // question: ["Are CGI Influencers Really the Future of Influencer Marketing?", "The influencer industry will become a blend of human and CGI influencers."],
    question: ["Who will dominate the fourth revolution?"],
    canvasParent: "question-general",
    text: "GENERAL",
    nextIDs: ["#gen-trend-03"],
    color: {
      r: 37,
      g: 216,
      b: 64
    }
  },
]

for (var i = 0; i < data.length; i += 1) {
  // sksketch, canvasParent, question, text, nextIDs, color
  new p5(function (sketch) {
    s(sketch, data[i].canvasParent, data[i].question, data[i].text, data[i].nextIDs, data[i].color)
  });
}